import React from 'react';
import styles from '../Operations.module.css';

interface BTGDComponent extends React.FC {
  title?: string;
}

const BTGD: BTGDComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Rolling 12 months B2B sales as compared to the immediately preceding 12 months.
        <br /><br />
        Determined by totaling sales of segmented business customers (instore and online) and National Accounts customers.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        This metric is dependent upon stores completing and maintaining their business customer segmentation.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        The goal is to work toward a healthy store model of 20% of total sales from B2B.
        <br /><br />
        Platinum and Pinnacle levels for Higher Ground can be achieved based on YOY Growth percentage rather than Growth $.
        <br /><br />
        The Growth $ goal is based on the Pinnacle level YOY Growth goal of 7% or more for the rolling 12-month period.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Consult with your Field Sales Manager and review/implement the Business-to-Business training and B2B Playbook to build the culture and practices to grow the relationships and sales with your local business customers.
        <br /><br />
         Sales training and product specific support are available in the form of B2B Vendor sales programs, B2B Monthly Sales Strategies with monthly vendor Lunch and Learn sales trainings. 
      </div>
    </div>
  );
};

BTGD.title = 'Business to Business (Growth $)';
export default BTGD;

